import React, { FC } from 'react'
import { Route } from 'react-router-dom'

type Props = {
  statusCode?: number
  children: React.ReactNode
}

const RouteStatus: FC<Props> = ({ statusCode, children }) => (
  <Route
    render={({ staticContext }) => {
      if (staticContext) {
        staticContext.statusCode = statusCode
      }
      return children
    }}
  />
)

export default RouteStatus
